// src/redux/reducers/profileReducer.js
import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
} from "../actions/profileActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PROFILE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PROFILE_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_PROFILE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PASSWORD_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_PASSWORD_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case UPDATE_PASSWORD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default profileReducer;
